import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {GermanTelOrFaxPipeModule, LazyPictureModule} from '@ed-clients/shared';

import {FindContactComponent} from './find-contact.component';

@NgModule({
  declarations: [FindContactComponent],
  imports: [
    CommonModule,
    LazyPictureModule,
    RouterModule,
    GermanTelOrFaxPipeModule,
    MatFormFieldModule,
    MatSelectModule
  ],
  exports: [FindContactComponent]
})
export class FindContactModule {
}
